/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Providers: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="providers" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M868.87 680L566.6666666666666 491.13V868.87L868.87 680zM1133.3333333333333 1133.3333333333333C1164.5 1133.3333333333333 1191.1333333333332 1122.2266666666667 1213.3466666666666 1100.0133333333333C1235.56 1077.8 1246.6666666666665 1051.1666666666667 1246.6666666666665 1020V340C1246.6666666666665 308.8333333333333 1235.56 282.2000000000001 1213.3466666666666 259.9866666666667A109.0833333333333 109.0833333333333 0 0 0 1133.3333333333333 226.6666666666668H113.3333333333333V1020C113.3333333333333 1051.1666666666667 124.44 1077.8 146.6533333333333 1100.0133333333333A109.0833333333333 109.0833333333333 0 0 0 226.6666666666667 1133.3333333333333H1133.3333333333333zM226.6666666666667 340H1133.3333333333333V1020H226.6666666666667V340z" : "M695.096 544L453.3333333333334 392.904V695.096L695.096 544zM906.6666666666669 906.6666666666666C931.6000000000003 906.6666666666666 952.9066666666668 897.7813333333334 970.6773333333334 880.0106666666667C988.448 862.24 997.3333333333334 840.9333333333333 997.3333333333334 816V272C997.3333333333334 247.0666666666666 988.448 225.76 970.6773333333334 207.9893333333333A87.2666666666667 87.2666666666667 0 0 0 906.6666666666669 181.3333333333333H90.6666666666667V816C90.6666666666667 840.9333333333333 99.552 862.24 117.3226666666667 880.0106666666667A87.2666666666667 87.2666666666667 0 0 0 181.3333333333334 906.6666666666666H906.6666666666669zM181.3333333333334 272H906.6666666666669V816H181.3333333333334V272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Providers.displayName = `Blueprint5.Icon.Providers`;
export default Providers;
